// DashboardChart.jsx
import React from "react";
import HorizonatlBarChart from "./dashboard-charts/horizonatalBar"; // Import HorizontalChart component
import ParagraphTag from "../../reusebale/Paragraph";
import db from "../../../db/index.json";

const RenewelSection = ({ subscriptionStats }) => {
  console.log("subscriptionStats", subscriptionStats);
  const { rightPanel } = db;

  return (
    <div className="dashboard-chart-container bg-white rounded-2xl mt-5 py-5 px-4 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
      <div className="">
        <ParagraphTag
          content={rightPanel.renewels}
          classes="text-darkColor font-popinsSemiBold text-base"
        />
        <ParagraphTag
          content={`Total Subscriptions: ${subscriptionStats?.subscriptionCount}`}
          classes="text-darkColor font-popinsSemiBold text-sm pt-4"
        />
      </div>

      {/* Include HorizontalChart here */}
      <div className="mt-4">
        <HorizonatlBarChart subscriptionStats={subscriptionStats} />
      </div>
    </div>
  );
};

export default RenewelSection;
